module.exports = __webpack_public_path__ + "media/images/aloe/icons/checkout/paypal-b23ba2cb1c052bf0f98b3553f9a131b9.svg";